import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageAdminInstructionsComponent } from './page.admin.instructions/page.admin.instructions.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageDriveComponent } from './page.drive/page.drive.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageChatbotComponent } from './page.chatbot/page.chatbot.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminSettingsComponent } from './page.admin.settings/page.admin.settings.component';
import { PageChatbotRoomComponent } from './page.chatbot.room/page.chatbot.room.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalPostDetailComponent,
        PageAdminInstructionsComponent,
        LayoutSidebarComponent,
        PageDriveComponent,
        PortalSeasonLoadingDefaultComponent,
        PageAccessComponent,
        PortalSeasonFormDropdownComponent,
        PortalSeasonPaginationComponent,
        PortalPostListComponent,
        PageChatbotComponent,
        PortalSeasonModalComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAdminSettingsComponent,
        PageChatbotRoomComponent,
        ComponentNavSidebarComponent,
        LayoutEmptyComponent,
        PortalSeasonTreeComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
